var exports = {
  "kL": "NoteEditSheet.module__container___MnUxaU",
  "Gv": "NoteEditSheet.module__backButton___MnUxaU",
  "j2": "NoteEditSheet.module__backIcon___MnUxaU",
  "eG": "NoteEditSheet.module__saveButton___MnUxaU",
  "AW": "NoteEditSheet.module__saveButtonActive___MnUxaU",
  "Qs": "NoteEditSheet.module__content___MnUxaU",
  "Pf": "NoteEditSheet.module__label___MnUxaU",
  "PC": "NoteEditSheet.module__textarea___MnUxaU",
};

module.exports = exports;
